import { Link } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { MAIN_REGION_ID } from "./useRegionToggle";

export const SkipToMainLink = () => {
  const { t } = useTranslation();
  return (
    <Link
      href={`#${MAIN_REGION_ID}`}
      onClick={(event) => {
        event.preventDefault();
        document.getElementById(MAIN_REGION_ID)?.focus();
      }}
      position="absolute"
      top="2"
      left="2"
      zIndex="skipLink"
      px="4"
      py="2"
      rounded="md"
      bg="smBackground"
      color="smPrimary"
      fontWeight="semibold"
      boxShadow="outline"
      transform="translateY(-200%)"
      _focusVisible={{ transform: "none" }}
      _focus={{ transform: "none" }}
    >
      {t("Skip to main content")}
    </Link>
  );
};
